// @flow
import {CardText} from "material-ui/Card"
import {Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import EditIcon from "material-ui/svg-icons/editor/mode-edit"
import IconButton from "material-ui/IconButton"
import * as React from "react"
import Snackbar from "material-ui/Snackbar"
import * as Util from "../common"

const M = Util.intlMessages("view.CharacterView")

export const StuckActionsError = containers.characters.StuckActionsError(
  props => {
    const {numPendingActions, open, onClose, error} = props
    if (error) return null
    return (
      <Snackbar
        open={open}
        message={
          <M
            id="stuckactions"
            values={{num: <Util.Num val={numPendingActions} />}}
          />
        }
        onRequestClose={onClose}
      />
    )
  },
)

function CharacterRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    charId,
    displayName,
    ownerName,
    userId,
    createdAt,
    readonly,
    setDisplayName,
    isCombatVisible,
  } = props
  const url = (readonly ? "/c/" : "/p/") + charId
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={displayName} />
          {readonly ? null : (
            <IconButton
              onClick={() => setDisplayName(prompt("Your swarm's new name: "))}
            >
              <EditIcon />
            </IconButton>
          )}
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        {readonly ? (
          <p>
            <M
              id="owner"
              values={{name: <Link to={"/u/" + userId}>{ownerName}</Link>}}
            />
          </p>
        ) : null}
        <p>
          <M id="created" values={{time: <Util.FromNow since={createdAt} />}} />
        </p>
        <p>
          <Link to={url + "/units"}>
            <M id="units" />
          </Link>
        </p>
        {isCombatVisible ? (
          <p>
            <Link to={url + "/combat"}>
              <M id="combat" />
            </Link>
          </p>
        ) : null}
        <p>
          <Link to={url + "/achievements"}>
            <M id="achievements" />
          </Link>
        </p>
        <p>
          <Link to={url + "/statistics"}>
            <M id="statistics" />
          </Link>
        </p>
        <StuckActionsError charId={charId} />
      </CardText>
    </div>
  )
}

export const CharacterRO = containers.characters.CharacterRO(
  Util.DumpProps(CharacterRender),
)
export const CharacterRW = containers.characters.CharacterRW(
  Util.DumpProps(CharacterRender),
)



// WEBPACK FOOTER //
// ./src/characters/CharacterView.js